import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const DEFAULT_COLOR = 'rgba(0, 0, 0, 0.85)';

export const XCloseIcon = ({
    color = DEFAULT_COLOR,
    className,
    sx,
    ...props
}) => (
    <SvgIcon
        className={className}
        viewBox="0 0 19 19"
        sx={{color, fontSize: 'inherit', ...sx}}
        aria-hidden="true"
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.195 9.5l7.68-7.68a.423.423 0 0 0 0-.6L17.781.124a.422.422 0 0 0-.3-.124.42.42 0 0 0-.3.124L9.5 7.806 1.818.124a.436.436 0 0 0-.6 0L.126 1.22a.423.423 0 0 0 0 .6l7.68 7.68-7.68 7.68a.423.423 0 0 0 0 .6l1.095 1.098a.431.431 0 0 0 .599 0L9.5 11.194l7.68 7.684a.429.429 0 0 0 .601 0l1.095-1.098a.425.425 0 0 0 0-.6L11.195 9.5z"
        />
    </SvgIcon>
);

export default XCloseIcon;
